var map = {
	"./pages/anagram-by-tag/anagram-by-tag.module": [
		"./src/app/pages/anagram-by-tag/anagram-by-tag.module.ts",
		"default~pages-anagram-anagram-module~pages-anagram-by-tag-anagram-by-tag-module~pages-dictionary-dic~29e8acee",
		"common",
		"pages-anagram-by-tag-anagram-by-tag-module"
	],
	"./pages/anagram/anagram.module": [
		"./src/app/pages/anagram/anagram.module.ts",
		"default~pages-anagram-anagram-module~pages-anagram-by-tag-anagram-by-tag-module~pages-dictionary-dic~29e8acee",
		"common",
		"pages-anagram-anagram-module"
	],
	"./pages/decks/decks.module": [
		"./src/app/pages/decks/decks.module.ts",
		"pages-decks-decks-module"
	],
	"./pages/dictionary/dictionary.module": [
		"./src/app/pages/dictionary/dictionary.module.ts",
		"default~pages-anagram-anagram-module~pages-anagram-by-tag-anagram-by-tag-module~pages-dictionary-dic~29e8acee",
		"common",
		"pages-dictionary-dictionary-module"
	],
	"./pages/find-my-word-by-tag/find-my-word-by-tag.module": [
		"./src/app/pages/find-my-word-by-tag/find-my-word-by-tag.module.ts",
		"default~pages-anagram-anagram-module~pages-anagram-by-tag-anagram-by-tag-module~pages-dictionary-dic~29e8acee",
		"common",
		"pages-find-my-word-by-tag-find-my-word-by-tag-module"
	],
	"./pages/find-my-word/find-my-word.module": [
		"./src/app/pages/find-my-word/find-my-word.module.ts",
		"default~pages-anagram-anagram-module~pages-anagram-by-tag-anagram-by-tag-module~pages-dictionary-dic~29e8acee",
		"common",
		"pages-find-my-word-find-my-word-module"
	],
	"./pages/flashcard/flashcard.module": [
		"./src/app/pages/flashcard/flashcard.module.ts",
		"default~pages-anagram-anagram-module~pages-anagram-by-tag-anagram-by-tag-module~pages-dictionary-dic~29e8acee",
		"common",
		"pages-flashcard-flashcard-module"
	],
	"./pages/game/game.module": [
		"./src/app/pages/game/game.module.ts",
		"pages-game-game-module"
	],
	"./pages/hangman-by-tag/hangman-by-tag.module": [
		"./src/app/pages/hangman-by-tag/hangman-by-tag.module.ts",
		"default~pages-anagram-anagram-module~pages-anagram-by-tag-anagram-by-tag-module~pages-dictionary-dic~29e8acee",
		"default~pages-hangman-by-tag-hangman-by-tag-module~pages-hangman-hangman-module",
		"common",
		"pages-hangman-by-tag-hangman-by-tag-module"
	],
	"./pages/hangman/hangman.module": [
		"./src/app/pages/hangman/hangman.module.ts",
		"default~pages-anagram-anagram-module~pages-anagram-by-tag-anagram-by-tag-module~pages-dictionary-dic~29e8acee",
		"default~pages-hangman-by-tag-hangman-by-tag-module~pages-hangman-hangman-module",
		"common",
		"pages-hangman-hangman-module"
	],
	"./pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"default~pages-anagram-anagram-module~pages-anagram-by-tag-anagram-by-tag-module~pages-dictionary-dic~29e8acee",
		"common",
		"pages-home-home-module"
	],
	"./pages/landing/landing.module": [
		"./src/app/pages/landing/landing.module.ts",
		"pages-landing-landing-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"pages-login-login-module"
	],
	"./pages/outdated/outdated.module": [
		"./src/app/pages/outdated/outdated.module.ts",
		"pages-outdated-outdated-module"
	],
	"./pages/prep-exams/prep-exams.module": [
		"./src/app/pages/prep-exams/prep-exams.module.ts",
		"default~pages-anagram-anagram-module~pages-anagram-by-tag-anagram-by-tag-module~pages-dictionary-dic~29e8acee",
		"common",
		"pages-prep-exams-prep-exams-module"
	],
	"./pages/profile/profile.module": [
		"./src/app/pages/profile/profile.module.ts",
		"default~pages-anagram-anagram-module~pages-anagram-by-tag-anagram-by-tag-module~pages-dictionary-dic~29e8acee",
		"common",
		"pages-profile-profile-module"
	],
	"./pages/register/register.module": [
		"./src/app/pages/register/register.module.ts",
		"pages-register-register-module"
	],
	"./pages/reset-password/reset-password.module": [
		"./src/app/pages/reset-password/reset-password.module.ts",
		"pages-reset-password-reset-password-module"
	],
	"./pages/route/route.module": [
		"./src/app/pages/route/route.module.ts",
		"pages-route-route-module"
	],
	"./pages/support/support.module": [
		"./src/app/pages/support/support.module.ts",
		"pages-support-support-module"
	],
	"./pages/word-of-the-day/word-of-the-day.module": [
		"./src/app/pages/word-of-the-day/word-of-the-day.module.ts",
		"default~pages-anagram-anagram-module~pages-anagram-by-tag-anagram-by-tag-module~pages-dictionary-dic~29e8acee",
		"common",
		"pages-word-of-the-day-word-of-the-day-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;